export const envConfig = {
  mode: import.meta.env.MODE || "dev",
  baseUrl: import.meta.env.VITE_BASE_URL || "/",
  apiUrl: import.meta.env.VITE_API_URL || "",
  apiPrefix: import.meta.env.VITE_API_URL_PREFIX || "/api",
  apiProxyEnabled: import.meta.env.VITE_API_PROXY_ENABLED === "true",
  subdomain: import.meta.env.VITE_SUBDOMAIN || "",
};

export function getApiBaseUrl() {
  if (envConfig.mode === "mock" || envConfig.apiProxyEnabled || !envConfig.apiUrl) {
    return envConfig.apiPrefix;
  }

  return `${envConfig.apiUrl}${envConfig.apiPrefix}`;
}
